import { render, staticRenderFns } from "./MainToolbar.vue?vue&type=template&id=2bb83413&scoped=true&"
import script from "./MainToolbar.vue?vue&type=script&lang=js&"
export * from "./MainToolbar.vue?vue&type=script&lang=js&"
import style0 from "./MainToolbar.vue?vue&type=style&index=0&id=2bb83413&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb83413",
  null
  
)

export default component.exports